import { InjectionToken } from "@angular/core";

export const SOCKET_LISTENER = new InjectionToken<SocketListener>('cwt-socket-listener');

export interface SocketListener {
    onSocketLoggedIn?(): void;
    onSocketConnected?(): void;
    onSocketLoggedOut?(): void;
}